/* MOSS Studio — cart drawer upsell.
   Delegated events (the drawer re-renders its inner HTML on every cart change,
   so listeners live on document, registered once).
   Add flow mirrors assets/moss-quick-add.js / product-form.js: POST to
   routes.cart_add_url with the sections the cart drawer renders, then hand the
   response to cart-drawer.renderContents(), which swaps in the fresh section
   HTML (line items, totals, this upsell block) and re-opens the drawer —
   no page reload, drawer stays open. */
(function () {
  function getCart() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  document.addEventListener('change', function (event) {
    if (!event.target.closest) return;
    var select = event.target.closest('[data-moss-upsell-select]');
    if (!select) return;
    var card = select.closest('[data-moss-upsell-card]');
    var price = card && card.querySelector('[data-moss-upsell-price]');
    var option = select.options[select.selectedIndex];
    if (price && option && option.dataset.price) price.textContent = option.dataset.price;
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var button = event.target.closest('[data-moss-upsell-add]');
    if (!button || button.disabled) return;
    var card = button.closest('[data-moss-upsell-card]');
    if (!card) return;

    var select = card.querySelector('[data-moss-upsell-select]');
    var variantId = select ? select.value : button.dataset.variantId;
    if (!variantId) return;

    var error = card.querySelector('[data-moss-upsell-error]');
    if (error) {
      error.textContent = '';
      error.hidden = true;
    }

    button.disabled = true;
    button.classList.add('is-loading');

    var cart = getCart();
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (cart && cart.getSectionsToRender) {
      try {
        formData.append(
          'sections',
          cart
            .getSectionsToRender()
            .map(function (section) {
              return section.id;
            })
            .join(',')
        );
      } catch (e) {}
      formData.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
    }

    var config;
    if (typeof fetchConfig === 'function') {
      config = fetchConfig('javascript');
    } else {
      config = { method: 'POST', headers: { Accept: 'application/json' } };
    }
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    var url = typeof routes !== 'undefined' && routes.cart_add_url ? routes.cart_add_url : '/cart/add.js';

    fetch(url, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        button.disabled = false;
        button.classList.remove('is-loading');
        if (response.status) {
          if (error) {
            error.textContent = response.description || response.message || '';
            error.hidden = false;
          }
          return;
        }
        if (cart && cart.renderContents) {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(response);
        } else {
          window.location = '/cart';
        }
      })
      .catch(function () {
        button.disabled = false;
        button.classList.remove('is-loading');
      });
  });
})();
